var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStarOutline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#003865",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m10.404 3.258 1.933 3.83 3.72.368a.465.465 0 0 1 .29.794l-3.063 3.035 1.135 4.125a.47.47 0 0 1-.665.54l-3.772-1.868-3.766 1.866a.47.47 0 0 1-.665-.54l1.135-4.125-3.064-3.035a.465.465 0 0 1 .288-.794l3.721-.369 1.93-3.827a.473.473 0 0 1 .843 0Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStarOutline);
export default ForwardRef;